export const TOTAL = "Total";
export const PAY_LATER_CANCELLATION_NO_SHOW_NOTES =
  "By booking this hotel reservation, you are consenting to Capital One and its service providers sharing your credit card information with the hotel property to hold your reservation and to be charged in the case of late cancellation or no-show.";
export const DUE_TODAY = "Due Today";
